export default __webpack_public_path__ + "static/media/FontAwesome5_Pro_Brands.c7698cbd.ttf";